import React from "react"

export const EntryPoint = () => {
  return (
    <div className="container">
      <div className="container_inner">
        <h1>Work in Progress</h1>
      </div>
    </div>
  )
}